import dayjs from 'dayjs';
import cookies from 'js-cookie';
import { getBotDetector } from '@zocdoc/bot-detection/dist/botDetector';
import { EventDataSchemaVersion, EVENT_TYPES } from '../../constants';
import { getPageId } from '../../utils/getPageId';
import { paths } from '../paths';

export const ENDPOINT_HOST = process.env.API_HOST || 'https://www.zocdoc.com';
export const ENDPOINT_PATH = '/eventslogging/v1/event';
export const ENDPOINT = `${ENDPOINT_HOST}${ENDPOINT_PATH}`;

export const LEGACY_LOCATION_CHANGE = '@@legacyRouting/LEGACY_LOCATION_CHANGE';

const madeItToSync = () => ({
    type: LEGACY_LOCATION_CHANGE,
    payload: {
        pathname: paths.legacySyncPath,
    },
});

export const logEvent = ({
    event,
    bookingId,
    businessUnit,
    dispatch,
    includeBookingId = true,
}) => {
    if (!event) {
        return;
    }

    if (bookingId) {
        if (event.type === EVENT_TYPES.DidShowSyncOverlay && dispatch) {
            dispatch(madeItToSync());
        }
    }

    if (businessUnit) {
        logEventToPatientDatalake({
            event,
            businessUnit,
            bookingId,
            includeBookingId,
        });
    }
};

export const logEventToPatientDatalake = ({
    event,
    businessUnit,
    bookingId,
    includeBookingId = true,
}) => {
    const botDetector = getBotDetector();
    const isRobot = botDetector.isBot(navigator.userAgent);

    const bookingIdToSend =
        bookingId === 'undefined' ? null : bookingId || null;

    const bsid = cookies.get('bsid');
    const firstTimeVisitor = cookies.get('firstTimeVisitor');

    // remove timestamp from browser session id cookie
    const sessionId =
        !bsid || bsid === null ? null : bsid.substr(0, bsid.indexOf('_'));
    const trackingId = firstTimeVisitor || null;

    const eventData = {
        BrowserTimestamp: dayjs().toISOString(),
        PageId: getPageId(),
        SessionId: sessionId,
        TrackingId: trackingId,
        UserAgent: navigator.userAgent,
        IsRobot: isRobot,
        ...event.data,
    };

    if (includeBookingId) {
        eventData.BookingId = bookingIdToSend;
    }

    const body = JSON.stringify({
        BusinessUnit: businessUnit,
        Name: event.type,
        Version:
            event.version || EventDataSchemaVersion[businessUnit][event.type],
        EventData: [eventData],
    });

    return fetch(ENDPOINT, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body,
    });
};
